import CompLayout from "@/pcomponents/comp/layout/layout";
import PaytCashHistoryListArea from "@/pages/comp/supply/payt/payt_cash/common/history_list";

function PaytCashListPage(props: any) {
  let myProps = {
    ...props
  };

  return (
    <CompLayout isConTitle={false}>
      <div className="con_wrap">
        <PaytCashHistoryListArea></PaytCashHistoryListArea>
      </div>
    </CompLayout>
  );
};
export default PaytCashListPage;